export default "__VITE_ASSET__DRg$eP56__"